import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { FeedbackMessage, MessageSeverity } from '../../types';

interface FeedbackState {
  messages: FeedbackMessage[];
}

const initialState: FeedbackState = {
  messages: [],
};

let messageCounter = 0;

const feedbackSlice = createSlice({
  name: 'feedback',
  initialState,
  reducers: {
    addMessage(state, action: PayloadAction<Partial<FeedbackMessage> & { message: string; severity: MessageSeverity }>) {
      const msg = action.payload;
      const id = msg.id || String(++messageCounter);
      const timeout = msg.timeout ?? 4000;

      // Remove existing message with same ID
      state.messages = state.messages.filter(m => m.id !== id);

      state.messages.push({
        ...msg,
        id,
        timeout,
      });
    },
    removeMessage(state, action: PayloadAction<string>) {
      state.messages = state.messages.filter(m => m.id !== action.payload);
    },
  },
});

export const { addMessage, removeMessage } = feedbackSlice.actions;
export default feedbackSlice.reducer;
